import {
    MentorClient
} from '../clients/MentorClient'
export const MentorModule = {
    namespaced: true,
    state: {
        mentors: [],
    },
    mutations: {

        SET_MENTORS(state, mentors) {
            state.mentors = mentors
        },

    },

    actions: {

        fetch({
                  commit
              }, payload) {
            return MentorClient.getMentors(payload).then(({
                                                              data
                                                          }) => {
                commit('SET_MENTORS', data.data)
            }).catch((err) => {
                console.log(err);

            });
        },

    },
};